import { media } from 'styled-bootstrap-grid'
import styled from 'styled-components'
import { Color } from '@ocean/theme'

export const Wrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;

  ${({ theme }) => `
    margin-top: ${theme.space.mobile.base};
    margin-bottom: ${theme.space.mobile.nano};
  `}

  ${({ theme }) => media.sm`
    margin-top: ${theme.space.desktop.base};
  `}
`

type ReferenceItemProps = {
  color: Color
  $pattern?: boolean
}

export const ReferenceItem = styled.div<ReferenceItemProps>`
  position: relative;
  flex-shrink: 0;
  padding-left: 30px;

  &:after {
    content: '';
    position: absolute;
    left: 0;
    top: 50%;
    margin-top: -10px;
    width: 20px;
    height: 20px;
  }

  ${({ theme, color, $pattern }) => `
    margin: 0 ${theme.space.mobile.large} ${theme.space.mobile.tiny} 0;

    &:after {
      background-color: ${theme.color[color]};
      ${$pattern ? `${theme.pattern};` : ''}
    }
  `}
`
